import {Component, OnInit} from '@angular/core';
import {APIService} from "../../services/APIService";
import {ScheduledAnnouncement} from "../../entities/server/ScheduledAnnouncement";
import {Server} from "../../entities/server/Server";

@Component({
  selector: 'app-announces-list',
  templateUrl: './servers.component.html',
  styleUrls: ['./servers.component.css']
})
export class ServersComponent implements OnInit {

  servers: Server[] = [];
  columns: string[] = ['id', 'identifier', 'ip', 'port', 'players'];

  constructor(public apiService: APIService) {
  }

  ngOnInit(): void {
    this.apiService.getServers().then((a) => this.servers = a);
  }
}
